import fetch from 'node-fetch';
import { BusinessModel } from '../../interfaces/BusinessModel.interface';
import rollbar from './rollbar';

const buildCustomer = (business: BusinessModel) => {
  return {
    company: business.name,
    id: business.id,
    cf_business_id: business.id,
    // Ensure we don't send `""` for custom fields
    cf_franchise_area: business.partner.franchiseCode || undefined,
    cf_affiliate_customer_id: business.partner.affiliateCustomerId || undefined,
    first_name: business.contact.firstName,
    last_name: business.contact.lastName || undefined,
    email: business.contact.email,
    // Ensure we don't send `""` for `phone`
    phone: (business.contact.phone && business.contact.phone.replace(/\D/g, '')) || undefined,
  };
};

const buildBillingAddress = (business: BusinessModel) => {
  return {
    first_name: business.contact.firstName,
    last_name: business.contact.lastName || undefined,
    company: business.name,
    line1: [business.address.unit, business.address.streetNumber, business.address.streetName]
      .filter(Boolean).join(' '),
    city: business.address.city,
    state_code: business.address.stateCode,
    zip: String(business.address.postalCode).toUpperCase(),
    country: business.address.country,
  };
};

const fetchChargebeeHostedPage = async ({ business, partnerCode, coupons }: {
  business: BusinessModel,
  partnerCode?: string,
  coupons: Array<string>
}) => {
  const path = `${process.env.NEXT_PUBLIC_ADMIN_API_URL}/businesses/chargebee/checkout/fromReservedIdToken?fields=url`;
  // @ts-ignore WRONG!
  const headers = new fetch.Headers({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-Api-Version': '1.0.10',
    'X-Sdk-Name': 'partner-intake',
    'X-Sdk-Version': '4.91.1',
  });
  const body = {
    itemPriceId: business.plan,
    code: partnerCode,
    customer: buildCustomer(business),
    billingAddress: buildBillingAddress(business),
    coupons,
    token: business.token,
    meta: business,
    itemPriceIds: business.addons?.map(addon => ({
      item_price_id: addon.id,
    })),
  };

  const response = await fetch(
    path,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    },
  );

  const json = await response.json();

  if (!response.ok) {
    const e = new Error(`${response.status} ${response.statusText}`);
    // @ts-ignore WRONG!
    e.response = response;
    // @ts-ignore I think you'll find `cause` _does_ exist on Error
    e.cause = json;
    rollbar.error(e);
    throw e;
  }

  return json.payload;
};

export default fetchChargebeeHostedPage;
